import { BellIcon, Logo, Typography, UserIcon } from '@/components/atoms';
import { BaseHeader } from '@/components/molecules/header/BaseHeader';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';

interface ProfileNotificationHeaderProps {
    title?: string;                    // Text to show in middle
    showLogo?: boolean;               // Show Bloom logo in middle
    onProfilePress?: () => void;
    onNotificationPress?: () => void;
    style?: ViewStyle;
}

export default function ProfileNotificationHeader({
    title,
    showLogo = false,
    onProfilePress,
    onNotificationPress,
    style
}: ProfileNotificationHeaderProps) {
    const colors = useUIColors();

    // Determine middle content
    const renderMiddleContent = () => {
        if (showLogo) {
            return (
                <View style={styles.logoContainer}>
                    <Logo color="white" size="large" />
                </View>
            );
        }

        if (title) {
            return (
                <Typography variant="title3" color="primary" style={styles.title}>
                    {title}
                </Typography>
            );
        }

        // Empty middle if neither logo nor title provided
        return <View style={styles.placeholder} />;
    };

    return (
        <BaseHeader
            style={style}
            leading={
                <TouchableOpacity
                    style={[styles.iconButton, { backgroundColor: colors.backgroundLevel1 }]}
                    onPress={onProfilePress}
                    activeOpacity={0.7}
                >
                    <UserIcon size={20} color={colors.fontPrimary} />
                </TouchableOpacity>
            }
            middle={renderMiddleContent()}
            trailing={
                <TouchableOpacity
                    style={[styles.iconButton, { backgroundColor: colors.backgroundLevel1 }]}
                    onPress={onNotificationPress}
                    activeOpacity={0.7}
                >
                    <BellIcon size={20} color={colors.fontPrimary} />
                </TouchableOpacity>
            }
        />
    );
}

const styles = StyleSheet.create({
    iconButton: {
        width: 36,
        height: 36,
        borderRadius: 18,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#404040',
        shadowOffset: {
            width: 0,
            height: 0,
        },
        shadowOpacity: 0.25,
        shadowRadius: 25,
        elevation: 8,
    },
    logoContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        textAlign: 'center',
        lineHeight: 24,
    },
    placeholder: {
        height: 40,
        width: 40,
    },
});
